import type { Tenant } from './types';

/** Exclusive boundary: all of 30 September in Europe/Madrid is included. */
export const FOUNDER_RESERVATION_ENDS_AT = '2026-09-30T22:00:00.000Z';
export function founderTrialActive(tenant: Tenant, now = Date.now()): boolean {
  return Boolean(tenant.founderPending && tenant.founderTrial && tenant.plan === 'trial'
    && tenant.subscriptionStatus === 'trialing' && !tenant.firstPaidAt
    && Date.parse(tenant.founderTrial.endsAt) > now);
}
export function founderReservationOpen(endsAt: string, now = Date.now()): boolean {
  return Date.parse(endsAt) > now;
}
